import webservice from '../../../../services/webservice';
import { createAsyncThunk } from '@reduxjs/toolkit'

export const getdata = createAsyncThunk('app/AppUpdate', async (data) => {
    try {
        const response = await fetch(webservice + 'api/AppUpdate', {
            body: JSON.stringify({ data }),
            method: 'POST',
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });

        const responseData = await response.json();        
        return responseData;
    } catch (error) {
        console.error('Error:', error);
        throw error; 
    }
});

export const updateApp = createAsyncThunk('app/updateApp', async (data) => {
    try {
        const response = await fetch(webservice + 'api/updateApp', {
            method: 'POST',
            body: JSON.stringify({ data }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error:', error);
        throw error; 
    }
});

export const getuserdata = createAsyncThunk('Dashboard/getuserdata', async () => {
    const response = await fetch(webservice + 'api/getuserdata', {
         method: 'GET',
         headers: {
              'Content-type': 'application/json; charset=UTF-8',
         },
    })
         .then((response) => response.json())
    return response;
})